import * as React from 'react';
import { WidgetWrapper } from '../core/DashbardGridStyledComponents';
const Nova = React.lazy(() =>
  import('nova-react-bridge').then(module => ({ default: module.Nova }))
);
/**
 * Hyper Nova Widget
 * @param data details of the hypernove entryPoints, widget params
 */
export const NovaWidgetRenderer: React.FC<any> = React.memo(
  ({ data, ...others }) => {
    const { name, props } = data;

    return (
      <WidgetWrapper {...others}>
        <React.Suspense fallback="Loading...">
          <Nova name={name} data={props} />
        </React.Suspense>
      </WidgetWrapper>
    );
  }
);
